import * as Types from '../constants/actionTypes';
const defaultState = {
    standardProfiles: [],
    countryProfiles: [],
    userServiceGroups: [],
}
export default (state = defaultState, action) => {
    switch (action.type) {
        case Types.CREATE_COUNTRY_PROFILE_SUCCESS:
            state.standardProfiles.push(action.payload)
            return {
                ...state
            }
        case Types.LIST_STANDARD_PROFILE_SUCCESS:
            return {
                ...state,
                standardProfiles: action.standardProfiles
            }
        case Types.COUNT_STANDARD_PROFILE_SUCCESS:
            return {
                ...state,
                countStandardProfiles: action.count
            }
        case Types.LIST_COUNTRY_PROFILE_SUCCESS:
            return {
                ...state,
                countryProfiles: action.countryProfiles
            }
        case Types.STANDARD_PROFILE_ERROR:
            return {
                ...state,
                    standardProfileError: action.payload
                }
        case Types.LIST_USER_SERVICE_GROUPS_SUCCESS:
            return {
                ...state,
                    userServiceGroups: action.data
                }
        default:
            return state
    }
}
